export const KeyTokensCookieStorage: string = 'tokens'
